import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import FieldValidationFreeTextArea from "../ui/inputs/field-validation-free-text-area.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-html-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The html content from parent component.
   * @type {String}
   * @required
   */
  displayedHtml: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the modal is closed.
   * This can be used to notify the parent component that the modal has been dismissed.
   */
  "modalClosed",
  /**
   * Emitted when the html content has changed.
   * This can be used to notify the parent component that the data has been updated.
   */
  "htmlUpdated",
],
  setup(__props, { emit }) {

const props = __props;





const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const editableHtml = ref("");

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onCancelClick = () => (showModal.value = false);

watch(
  () => showModal.value,
  () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    editableHtml.value = props.displayedHtml;
  },
);

watch(
  () => editableHtml.value,
  () => {
    displayCancelConfirmationModal.value =
      editableHtml.value != props.displayedHtml;
  },
  { deep: true },
);

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed");
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const onSaveClick = async () => {
  displayCancelConfirmationModal.value = false;
  showModal.value = false;
  emit("htmlUpdated", editableHtml.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    title: "HTML",
    onCancelPromptDenied: cancelPromptDenied,
    onModalClosed: modalClosed,
    showCloseConfirmationPrompt: displayCancelConfirmationModal.value
  }, {
    content: _withCtx(() => [
      _createVNode(FieldValidationFreeTextArea, {
        modelValue: editableHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableHtml).value = $event)),
        height: "25rem"
      }, null, 8, ["modelValue"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "showCloseConfirmationPrompt"]))
}
}

})